const REGION_DISPLAY = (() => {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" });
  } catch {
    return null;
  }
})();

/**
 * Resolves an ISO 3166-1 alpha-2 country code to its English display name.
 * Falls back to the raw code when the code is missing or unresolvable.
 */
export const countryName = (code?: string): string => {
  if (!code) return "";

  try {
    return REGION_DISPLAY?.of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
};
